import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import {userWallet} from "../../network/api/Wallet.js"
const WalletPopup = ({ show, onHide }) => {
  const [walletAmount, setWalletAmount] = useState("");

  const handleWalletSubmit = async () => {
    // Handle wallet submission logic here
    // You can use the walletAmount state for the value entered by the user
    // onSubmit(walletAmount);
     userWallet(walletAmount).then((response)=>{
      window.location.href = `${response.data.response.url}`
      setWalletAmount("");
    })
    
     // Clear the wallet amount after submission
  };

  const handleInputChange = (e) => {
    // Allow only positive numbers
    let inputValue = e.target.value.replace(/^0+|[^0-9]+$/g, "");
    setWalletAmount(inputValue);
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Enter Wallet Amount</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Label>Amount:</Form.Label>
          <Form.Control
            type="number"
            id="walletInput"
            value={walletAmount}
            onChange={handleInputChange}
            isInvalid={isNaN(walletAmount) || walletAmount < 0}
          />
          <Form.Control.Feedback type="invalid">
            Please enter a valid positive number.
          </Form.Control.Feedback>
        </Form.Group>
      </Modal.Body>

      <div className="d-flex justify-content-center p-3">
        <Button
          variant="primary"
          style={{ backgroundColor: "#d99d2b", border: "none" }}
          onClick={handleWalletSubmit}
          disabled={isNaN(walletAmount) || walletAmount <= 0}
        >
          Submit
        </Button>

        <Button
          style={{
            backgroundColor: "#d99d2b",
            border: "none",
            marginLeft: "5px",
          }}
          onClick={() => {
            onHide();
          }}
        >
          Close
        </Button>
      </div>
    </Modal>
  );
};

export default WalletPopup;
